import { PreviewPlayer } from "@components/video"
import { Container } from "@components/wrapper"
import { SchoolVideoPreview } from "@interfaces/school"
import clsx from "clsx"
import React from "react"
import Carousel, { DotProps } from "react-multi-carousel"
import { BootcampSliderArrow, SliderScrollArrow } from "."
import { BootcampHeading } from "../general/ProgramHeading"

const CustomDot = ({ active, onClick }: DotProps) => {
  return (
    <button
      className={clsx(
        "wh-3 rounded-full mx-1.5 border-0 transition-all duration-200",
        active ? "bg-blue" : "bg-grey-c4 w-auto rounded-0"
      )}
      onClick={(e) => {
        if (onClick) {
          onClick()
        }
        e.preventDefault()
      }}
    />
  )
}

const BootcampVideo = ({ videos, screenWidth }: { videos: SchoolVideoPreview[], screenWidth: number }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  const youtubeOnly = videos.filter((d) => d.video_link.includes("youtube") || d.video_link.includes("youtu.be"))

  if (!youtubeOnly.length) {
    return <></>
  }


  return (
    <div className="bg-[#101820] sm:py-20 py-10">
      <Container className="relative">
        <div className="relative sm:gap-15 gap-4.5 sm:flex grid">
          <div className="sm:flex-1 flex flex-col justify-center">
            <div className="w-4/5 relative">
              <BootcampHeading
                id="preview"
                title="cuplikan"
                subTitle="Serunya Belajar di Harisenin.com"
                type="green"
              />
            </div>
          </div>

          <div className="sm:w-[45vw]">
            <div className="sm-only:w-[90vw]">
              <Carousel
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                containerClass={clsx("sm:-ml-4 sm:py-5 px-0 gap-5 sm-only:-mx-2.5")}
                itemClass="sm-only:mb-5"
                arrows={false}
                {...(screenWidth > 576 && {
                  customButtonGroup: (
                    <BootcampSliderArrow
                      displayedSlide={1}
                      length={youtubeOnly.length}
                      className="gap-6 justify-end"
                    />
                  ),
                  renderButtonGroupOutside: true,
                })}
                {...(screenWidth < 576 && {
                  renderArrowsWhenDisabled: true,
                  renderButtonGroupOutside: true,
                  partialVisible: true,
                  customButtonGroup: (
                    <SliderScrollArrow
                      length={youtubeOnly.length}
                      displayedSlide={1}
                      customBackground="bg-[#2D343B]"
                      customMargin="mt-6"
                    />
                  ),
                  autoPlaySpeed: 3000,
                })}
              >
                {youtubeOnly.map((value, i) => (
                  <PreviewPlayer
                    url={value.video_link}
                    thumbnail={value.video_thumbnail}
                    key={i}
                    className="sm:!h-[28vw] !rounded-lg"
                  />
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default BootcampVideo
